import cloudflareLoader from "@/lib/cloudflare-images";
import clsx from "clsx";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";

const MiniChefBio = ({ chef }) => {
  return (
    <Link
      href={`/${chef.uri}`}
      className="flex w-fit items-center justify-start gap-2.5 md:justify-start"
    >
      {chef.image[0] && (
        <div className={clsx("h-component w-component")}>
          <div className="relative block aspect-square">
            <Image
              src={chef.image[0].url}
              alt={chef.title}
              layout="fill"
              className="rounded-full object-cover"
              loader={cloudflareLoader}
            />
          </div>
        </div>
      )}
      <h3 className="font-body text-sm font-medium">{chef.title}</h3>
    </Link>
  );
};

export default MiniChefBio;
